import { createAsyncThunk } from '@reduxjs/toolkit';

import { APITenantUserMembershipPost, APITenantUserMembershipPut, APITenantUserProfileMembershipDelete } from '../TenantUserMembership/TenantUserMembership.api';

import { APIUserProfileAppsGet } from './UserProfileApps.api';

export const fetchUserProfileApps = createAsyncThunk('userApps/fetchUserProfileApps', async (item: {userId: string}) => {
    const response = await APIUserProfileAppsGet(item);
    return response.data;
});

export const postUserProfileTenantMembership = createAsyncThunk(
    'userApps/postUser',
    async (item: {
        tenantId: string;
        userId: string;
        notes: string;
        globalRoles: {
            id: string;
        }[];
        startDate: string;
        endDate?: string;
    }) => {
        return APITenantUserMembershipPost(item);
    }
);

export const putUserProfileTenantMembership = createAsyncThunk(
    'userApps/putUser',
    async (item: {
        tenantId: string;
        userId: string;
        notes: string;
        globalRoles: {
            id: string;
        }[];
        startDate: string;
        endDate?: string;
    }) => {
        return APITenantUserMembershipPut(item);
    }
);

export const deleteUserProfileDeleteMembership = createAsyncThunk(
    'userApps/deleteUserProfileMembership',
    async (item: {
        tenantId: string;
        userId: string;
    }) => {
        return APITenantUserProfileMembershipDelete(item);
    }
);
